function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

let language = 'en';
const table = {
  [language]: {}
};

const parse = (textKey, data) => {
  const template = table[language][textKey] || table[language][textKey.toLowerCase()] || textKey;
  return !data ? template : template.replace(/{([\w.]*)}/g, function (_str, key) {
    const keys = key.split('.');
    let v = data;

    for (let i = 0, l = keys.length; i < l; i++) {
      if (v.hasOwnProperty(keys[i])) {
        v = v[keys[i]];
      } else {
        return _str;
      }
    }

    return v;
  });
};

export default function _() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Is Tagged Literal
  if (args[0].raw) {
    const raw = String.raw.call(null, ...args);
    return parse(raw);
  }

  return parse(...args);
}
export const getLanguage = () => language;
export const getTable = () => table;
export const setLanguage = l => {
  language = l;
  table[l] = table[l] || {};
};
export const setTable = t => {
  for (const [lang, translations] of Object.entries(t)) {
    table[lang] = _extends(table[lang] || {}, translations);
  }
};

String.prototype.withData = // eslint-disable-line
String.prototype.withData || function (data) {
  return parse(this, data);
};